"use client";
import * as React from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { useRouter } from "next/navigation";
import { useSession } from "next-auth/react";

interface PayPalButtonProps {
	planId: string;
	tier: string;
	userId: string | undefined;
}

export const PayPalButton: React.FC<PayPalButtonProps> = ({
	planId,
	tier,
	userId,
}) => {
	const router = useRouter();
	const handleTransactionComplete = async (
		subscriptionId: string,
		tier: string
	) => {
		await fetch("/api/transactions", {
			method: "POST",
			body: JSON.stringify({
				subscriptionId,
				tier,
			}),
		});
		
		sessionStorage.removeItem("startingTrial");
		router.push(`/profile/${userId}`);
	};

	return (
		<PayPalButtons
			className="relative z-[1]"
			createSubscription={(data, actions) => {
				return actions.subscription.create({
					plan_id: planId,
				});
			}}
			onApprove={(data) =>
				handleTransactionComplete(data.subscriptionID!, tier)
			}
		/>
	);
};
